/* IMAGES */
/* Demencia */
import DementiaPng from '../../assets/img/photos/png/Demencia_small.png';
import DementiaJpg from '../../assets/img/photos/jpg/Demencia_small.jpg';
import DementiaWebp from '../../assets/img/photos/webp/Demencia_small.webp';

/* Caídas */
import FallsPng from '../../assets/img/photos/png/Caidas_small.png';
import FallsJpg from '../../assets/img/photos/jpg/Caidas_small.jpg';
import FallsWebp from '../../assets/img/photos/webp/Caidas_small.webp';

/* Pérdida de memoria */
import MemoryLossPng from '../../assets/img/photos/png/Perdida_memoria_small.png';
import MemoryLossJpg from '../../assets/img/photos/jpg/Perdida_memoria_small.jpg';
import MemoryLossWebp from '../../assets/img/photos/webp/Perdida_memoria_small.webp';

/* Trastorno del sueño */
import SleepDisorderPng from '../../assets/img/photos/png/Trastorno_suenio_small.png';
import SleepDisorderJpg from '../../assets/img/photos/jpg/Trastorno_suenio_small.jpg';
import SleepDisorderWebp from '../../assets/img/photos/webp/Trastorno_suenio_small.webp';

/* Depresión */
import DepressionPng from '../../assets/img/photos/png/Depresion_small.png';
import DepressionJpg from '../../assets/img/photos/jpg/Depresion_small.jpg';
import DepressionWebp from '../../assets/img/photos/webp/Depresion_small.webp';

/* Parkinson */
import ParkinsonPng from '../../assets/img/photos/png/Parkinson_small.png';
import ParkinsonJpg from '../../assets/img/photos/jpg/Parkinson_small.jpg';
import ParkinsonWebp from '../../assets/img/photos/webp/Parkinson_small.webp';

/* Patologías crónicas  */
import ChronicPathologiesPng from '../../assets/img/photos/png/Patologias_cronicas_small.png';
import ChronicPathologiesJpg from '../../assets/img/photos/jpg/Patologias_cronicas_small.jpg';
import ChronicPathologiesWebp from '../../assets/img/photos/webp/Patologias_cronicas_small.webp';



/* PATOLOGÍAS INFO */

let pathology = [
    {
        id: 1,
        pathology: 'Demencia',
        description: 'La demencia es un término general para describir un deterioro cognitivo progresivo que afecta la memoria, el pensamiento, el comportamiento y la capacidad para realizar actividades diarias. Es causada por diversas condiciones, como la enfermedad de Alzheimer. Los síntomas incluyen pérdida de memoria, confusión, cambios en la personalidad y dificultad para tomar decisiones.',
        srcWebp: DementiaWebp,
        srcPng: DementiaPng,
        srcJpg: DementiaJpg, 
        altImg: "Demencia", 
        active: true,
    },
    {
        id: 2,
        pathology: 'Caídas',
        description: 'Las caídas producidas por falta de equilibrio son comunes en personas mayores y pueden ser causadas por factores como debilidad muscular, problemas de visión, medicamentos, trastornos del equilibrio o superficies inseguras. Las caídas pueden causar lesiones importantes como fracturas o contusiones, por lo que es importante prevenirlas mediante ejercicios de fortalecimiento, revisiones de medicación y adaptaciones en el hogar.',
        srcWebp: FallsWebp,
        srcPng: FallsPng,
        srcJpg: FallsJpg, 
        altImg: "Caídas", 
        active: false,
    },
    {
        id: 3,
        pathology: 'Pérdida de memoria',
        description: 'La pérdida de memoria es la incapacidad para recordar información o eventos, que puede ser temporal o permanente. Puede ser un síntoma de diversas condiciones, como el envejecimiento, el estrés, la ansiedad, la depresión o enfermedades neurodegenerativas. Los síntomas incluyen olvidos frecuentes, dificultad para recordar nombres, fechas o eventos recientes, y problemas para retener nueva información.',
        srcWebp: MemoryLossWebp,
        srcPng: MemoryLossPng,
        srcJpg: MemoryLossJpg, 
        altImg: "Pérdida de memoria", 
        active: false,
    },
    {
        id: 4,
        pathology: 'Trastorno del sueño',
        description: 'El trastorno del sueño es una condición que afecta la calidad, el tiempo o la cantidad de sueño, dificultando el descanso adecuado y suele darse en población geriátrica. Los síntomas incluyen insomnio, somnolencia excesiva durante el día, dificultad para conciliar el sueño o mantenerse dormido, y ronquidos o apneas. ',
        srcWebp: SleepDisorderWebp,
        srcPng: SleepDisorderPng,
        srcJpg: SleepDisorderJpg, 
        altImg: "Trastorno del sueño", 
        active: false,
    },
    {
        id: 5,
        pathology: 'Depresión',
        description: 'Trastorno del estado de ánimo que afecta con frecuencia a las personas mayores, caracterizado por sentimientos persistentes de tristeza, desesperanza y pérdida de interés en las actividades diarias. A menudo, se presenta de manera diferente en los mayores, con síntomas como cansancio extremo, irritabilidad, cambios en el apetito o el sueño, y dificultades para concentrarse. La depresión en este grupo etario puede estar asociada con enfermedades crónicas, pérdidas significativas o aislamiento social.',
        srcWebp: DepressionWebp,
        srcPng: DepressionPng,
        srcJpg: DepressionJpg, 
        altImg: "Depresión", 
        active: false,
    },
    {
        id: 6,
        pathology: 'Parkinson',
        description: 'El Parkinson es una enfermedad neurodegenerativa crónica que afecta el sistema nervioso central, provocando temblores, rigidez muscular, lentitud de movimiento y alteraciones en el equilibrio y la coordinación. En personas sobre los 55 años, los síntomas suelen empeorar progresivamente y pueden estar acompañados de problemas cognitivos. Aunque no tiene cura, el tratamiento incluye medicamentos y terapias para mejorar la calidad de vida y controlar los síntomas.',
        srcWebp: ParkinsonWebp,
        srcPng: ParkinsonPng,
        srcJpg: ParkinsonJpg, 
        altImg: "Parkinson", 
        active: false,
    },
    {
        id: 7,
        pathology: 'Patologías crónicas',
        description: 'Las patologías crónicas son enfermedades de larga duración que afectan la calidad de vida en los adultos mayores. Entre las más comunes se encuentran la hipertensión, diabetes tipo 2, artrosis, enfermedades cardiovasculares, enfermedad pulmonar obstructivas, insuficiencia renal crónica y muchas más. Estas condiciones requieren un manejo integral geriátrico para mejorar la funcionalidad y prevenir complicaciones a largo plazo.',
        srcWebp: ChronicPathologiesWebp,
        srcPng: ChronicPathologiesPng,
        srcJpg: ChronicPathologiesJpg, 
        altImg: "Patologías crónicas", 
        active: false,
    },
]

export default pathology;